import { ChevronRightIconComponent } from '../../icons/chevron-right-icon.component';
import { CommonModule, Location } from '@angular/common';
import {
  Component,
  OnDestroy,
  OnInit,
  ViewChild,
  inject,
  ChangeDetectorRef,
  ChangeDetectionStrategy,
} from '@angular/core';
import { ActivatedRoute, RouterModule } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';
import { BaseComponent } from '../../../../base/components/base.component';
import { ProductService } from '../../../service/product.service';
import { InverterType, PlantTypeEnum, StatsData } from '../../../models/stats';
import {
  INVERTER_TYPE,
  PLANT_TYPE,
  SELECTED_PLANT_NAME,
  USER_KEY,
} from '../../../service/storage.service';
import { PlantItemData, PlantListData } from '../../../models/plants';

import { WeatherService } from '../../../service/weather.service';

import {
  NotificationData,
  NotificationResponseData,
} from '../../../models/notification';
import { DateUtils, NoxMonth, NoxYear } from '../../../utils/date_utils';
import { NoxInverterType, TrendSelection, TrendType, SelectionType } from '../../../models/enum';
import { NoxDropdown, getTrendsDropDown } from '../../../models/dropdown';
import { EnergyFlowComponent } from '../../../../customer/components/energy-flow/energy-flow.component';
import { ClickOutsideDirective } from '../../../utils/click.outside.directive';
import { User, UserType } from '../../../models/user';
import { WeatherForecastComponent } from '../../weather-forecast/weather-forecast.component';
import { MatSidenavModule } from '@angular/material/sidenav';
import { PlantDetail } from '../../../models/plant';
import { TrendsComponent } from '../../trends/trends.component';
import { PlantOnlineData } from '../../../models/plant-online-ratio';
import { Subject, takeUntil } from 'rxjs';

import {
  NoxDialogParam,
  NoxDialogType,
} from '../../../models/nox-dialog-param';
import { MatDialog } from '@angular/material/dialog';
import { NoxDialogComponent } from '../../nox-dialog/nox-dialog.component';
import { EnvironmentalBenefitsComponent } from "../../../../environmental-benefits/environmental-benefits.component";
import { WifiIconComponent } from '../../icons/wifi-icon.component';
import { ClickableDirective } from '../../../directives/clickable.directive';
import { WeatherDetailsResponse } from '../../../models/weather-details';
@Component({
  selector: 'app-customer-dashboard',
  templateUrl: './customer-dashboard.component.html',
  styleUrl: './customer-dashboard.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    RouterModule,
    CommonModule,
    TranslateModule,
    EnergyFlowComponent,
    ClickOutsideDirective,
    WeatherForecastComponent,
    MatSidenavModule,
    TrendsComponent,
    EnvironmentalBenefitsComponent,
    ClickableDirective,
    WifiIconComponent,
    ChevronRightIconComponent
  ],
})
export class CustomerDashboardComponent
  extends BaseComponent
  implements OnDestroy, OnInit {

  changeRotation: boolean = false;
  showGeneralInfo: boolean = false;
  increaseInfoBoxSize: boolean = false;
  changeLineHeight: boolean = false;
  plantSelected!: string | null;
  iconUrl: string = '';
  private readonly cdr = inject(ChangeDetectorRef);
  toggleTrendDropdown() {
    this.enableTrendDropdown = !this.enableTrendDropdown;
  }

  increaseSize() {
    this.showGeneralInfo = !this.showGeneralInfo;
    this.changeRotation = !this.changeRotation;
    this.increaseInfoBoxSize = !this.increaseInfoBoxSize;
    this.changeLineHeight = !this.changeLineHeight;
  }
  previewImage(url?: string) {
    let noxDialogData: NoxDialogParam = {
      type: NoxDialogType.image,
      imageUrl: url,
    };
    this.dialog.open(NoxDialogComponent, {
      data: noxDialogData,
    });
  }
  addNewPlantPopup() {
    let noxDialogData: NoxDialogParam = {
      type: NoxDialogType.info,
      title: 'Adding New Plant?',
      messageList: [
        'Currently, adding a new plant is only available through the mobile app.',
        'To add new plant, ensure that your device is powered on.',
        'Check the functionality of the router connected to your device. ',
        'Check if the router has internet connection.',
        'Confirm your device is in range of the router. ',
        'Confirm the signal strength is good, or if any obstruction is affecting data transmission.',
        "Confirm whether the wifi router's name or password has been changed. If yes, then please configure the device. ",
      ],
      disclaimer:
        "During configuration, ensure you have the latest ConnectX app installed and that you're near the device with a strong WiFi signal.",
    };
    this.dialog.open(NoxDialogComponent, {
      data: noxDialogData,
    });
  }

  activatePlant() {
    if (this.selectedPlant) {
      this.spinner.show();
      this.prodService.activatePlant(this.selectedPlant.id).subscribe({
        next: (res) => {
          this.spinner.hide();
          if (res.status == 200 || res.status == 201) {
            this.isPlantDeactivated = false;
            this.toastr.success(res.message);
            this.resolveAllSubscriptions([
              this.fetchStats(this.selectedPlant!.id),
            ]);
            this.cdr.detectChanges();
          }
        },
        error: (err) => {
          this.logger.error(err);
          this.spinner.hide();
        },
      });
    }
  }
  getStrengthImage(strength: number | undefined) {
    let imageName = 'strength-' + strength;

    return imageName;
  }
  dropdownVisible = false;
  dialog = inject(MatDialog);
  selectionType = SelectionType
  yearDropdownVisible = false;
  notificationDropdownVisible = false;

  enableTrendDropdown = false;
  statData?: StatsData | null;
  isNav: number = 0;
  prodService = inject(ProductService);
  weatherService = inject(WeatherService);
  plantList?: PlantListData;
  selectedPlantId: string = '';
  currentWeather?: WeatherDetailsResponse;
  notificationList?: NotificationData[];

  trendSelection = TrendSelection.DAY;
  trendType = TrendType.POWER_GENERATION;
  platType = PlantTypeEnum;
  noxMonthsData = NoxMonth.noxMonthsData();
  yearList = NoxYear.yearList();
  todayDate = new Date();
  trendDropdown: NoxDropdown[] = getTrendsDropDown();
  selectedTrend!: NoxDropdown;
  generationData: boolean = true;
  inverterType = InverterType;
  selectedPlant?: PlantDetail | null;
  isDeviceOffline: boolean = true;
  plantRatioData?: PlantOnlineData;
  private readonly ngUnsubscribe: Subject<void> = new Subject<void>();
  userType = UserType;
  plantData?: PlantDetail;
  isPlantDeactivated = false;
  isPlantEmptyUser = false;
  showNoDataScreen: boolean = false;
  @ViewChild(WeatherForecastComponent) sideSheet!: WeatherForecastComponent;
  user: User | undefined;
  location = inject(Location);
  private readonly destroy$ = new Subject<void>();

  constructor(private readonly route: ActivatedRoute
  ) {
    super();

    this.user = this.storageService.getObject(USER_KEY);
  }
  noxInverterType = NoxInverterType

  ngOnInit(): void {
    this.selectedTrend = this.trendDropdown[0];
    this.plantSelected = this.storageService.get(SELECTED_PLANT_NAME);
    this.initializeData();
    this.trendDropdown = getTrendsDropDown()
      .filter(item => item.key !== 'power-cut');
     
  }

  private initializeData(): void {
    if (this.user?.user_type === this.userType.CUSTOMER) {
      this.resolveAllSubscriptions([this.fetchPlantList()]);
    }
    this.plantSelected = this.storageService.get(SELECTED_PLANT_NAME);
    this.route.queryParams.subscribe((params) => {
      let plantId = params['plantId'];
      localStorage.setItem('pId', params['plantId']);
      if (this.user?.user_type === this.userType.CUSTOMER) {
        this.prodService.plantList.pipe(takeUntil(this.ngUnsubscribe)).subscribe({
          next: (plantResponse) => {
            if (plantResponse) {
              this.plantList = plantResponse;
              if (!plantId) {
                if (this.plantList.primaryPlant.length > 0) {
                  plantId = this.plantList.primaryPlant[0].id;
                } else if (this.plantList.secondaryPlant.length) {
                  plantId = this.plantList.secondaryPlant[0].id;
                } else {
                  this.toastr.info('No plant found');
                }
              }

              const combinedPlantList: PlantItemData[] = [
                ...this.plantList.primaryPlant,
                ...this.plantList.secondaryPlant,
              ];
              const selectedPlant = (id: string): PlantItemData | undefined => {
                return combinedPlantList.find((plant) => plant.id === id);
              };
              this.isPlantDeactivated = selectedPlant(plantId)?.deleted ?? false;
              if (this.user?.user_type != UserType.SYSTEM_INTEGRATOR) {
                this.isPlantEmptyUser =
                  this.plantList?.primaryPlant.length == 0 &&
                  this.plantList?.secondaryPlant.length == 0;
              }
              if (!this.isPlantDeactivated && !this.isPlantEmptyUser) {
                this.resolveAllSubscriptions([this.fetchStats(plantId)]);
              }
            }
          },
          error: (err) => { },
        });
      } else {
        this.resolveAllSubscriptions([this.fetchStats(plantId)])
      }
    });

    this.prodService.selectedPlant.pipe(takeUntil(this.ngUnsubscribe)).subscribe((plant) => {
      this.selectedPlant = plant;
      const plantName = plant?.plantName;
      localStorage.setItem('plantname', plantName ?? '');
      this.cdr.detectChanges();
    });
  }

  /**
   * Handle plant list updates when available
   */
  private handlePlantListUpdate(plantId: string | undefined): void {
    this.prodService.plantList.pipe(takeUntil(this.ngUnsubscribe)).subscribe({
      next: (plantResponse) => {
        if (plantResponse) {
          this.plantList = plantResponse;
          plantId = this.resolvePlantId(plantId);

          const combinedPlantList: PlantItemData[] = [
            ...this.plantList.primaryPlant,
            ...this.plantList.secondaryPlant,
          ];
          const findPlant = (id: string): PlantItemData | undefined => {
            return combinedPlantList.find((plant) => plant.id === id);
          };
          this.isPlantDeactivated = findPlant(plantId ?? '')?.deleted ?? false;
          if (this.user?.user_type != UserType.SYSTEM_INTEGRATOR) {
            this.isPlantEmptyUser =
              this.plantList?.primaryPlant.length == 0 &&
              this.plantList?.secondaryPlant.length == 0;
          }

          this.cdr.detectChanges();

          if (!this.isPlantDeactivated && !this.isPlantEmptyUser && plantId) {
            this.resolveAllSubscriptions([this.fetchStats(plantId)]);
          }
        }
      },
      error: () => { },
    });
  }

  /**
   * Resolve plant ID from params or default to first available
   */
  private resolvePlantId(plantId: string | undefined): string | undefined {
    if (!plantId && this.plantList) {
      if (this.plantList.primaryPlant.length > 0) {
        return this.plantList.primaryPlant[0].id;
      } else if (this.plantList.secondaryPlant.length) {
        return this.plantList.secondaryPlant[0].id;
      } else {
        this.toastr.info('No plant found');
        return undefined;
      }
    }
    return plantId;
  }

  fetchPlantList() {
    let loaderSubject = new Subject<boolean>();
    let user: User = this.storageService.getObject(USER_KEY);

    this.prodService.getPlantList(user.id).subscribe({
      next: (plantResponse) => {
        if (
          plantResponse.status == 204 &&
          this.user?.user_type != UserType.SYSTEM_INTEGRATOR
        ) {
          this.toastr.info('No plant found');
          this.plantList = {
            primaryPlant: [],
            secondaryPlant: [],
          };
          this.isPlantEmptyUser = true;
        } else {
          this.plantList = plantResponse.body?.data;
        }

        this.cdr.detectChanges();
        loaderSubject.next(true);
      },
      error: (err) => {
        this.logger.error(err);
        loaderSubject.next(true);
      },
      complete: () => loaderSubject.complete(),
    });
    return loaderSubject;
  }
  ngOnDestroy(): void {
    this.ngUnsubscribe.next();
    this.ngUnsubscribe.complete();
    this.destroy$.next();
    this.destroy$.complete();

  }

  /**
   * Fetch plant overview data one after another
   */
  fetchPlantOverview() {
    this.fetchPlantDetail();
    this.fetchNotification();
    this.fetchPlantOnlineRatio();
  }

  /**
   * Plant online ratio
   */
  fetchPlantOnlineRatio() {
    this.prodService
      .getPlantOnlineRatio(this.selectedPlantId)
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe({
        next: (plantResponse) => {
          this.plantRatioData = plantResponse.data;
          this.cdr.detectChanges();
        },
        error: (err) => {
          this.logger.error(err);
        },
      });
  }

  /**
   * Fetch particular data of plant
   */
  fetchPlantDetail() {
    this.prodService
      .getPlantDetail(this.selectedPlantId)
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe({
        next: (plantResponse) => {
          this.plantData = plantResponse.data;
          this.fetchWeatherDetails(this.plantData.lat, this.plantData.lon);
          this.cdr.detectChanges();
        },
        error: (err) => {
          this.logger.error(err);
        },
      });
  }

  /**
   * Fetch notification of plant
   */
  fetchNotification() {
    let user: User = this.storageService.getObject(USER_KEY);

    this.prodService
      .getNotifications(this.selectedPlantId, user.id)
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe({
        next: (notificationResponse: NotificationResponseData) => {
          let notifications: NotificationData[] = [];
          notificationResponse?.data.forEach((notification) => {
            notification.notificationDate = DateUtils.formatDateFromLocalEpoch(
              notification.data.timestamp * 1000,
              'DD/MM/YYYY hh:mm a',
            );
            notifications.push(notification);
          });
          this.notificationList = notifications;
          this.cdr.detectChanges();
        },
        error: (err) => {
          this.logger.error(err);
        },
      });
  }
  fetchWeatherDetails(lat: number, lon: number) {
    this.weatherService.getWeatherDetails(lat, lon).pipe(takeUntil(this.ngUnsubscribe)).subscribe({
      next: (weatherResponse: WeatherDetailsResponse) => {
        const iconUrl =
          `https://openweathermap.org/img/wn/${weatherResponse.weather[0].icon}@2x.png`;
        this.iconUrl = iconUrl;
        this.currentWeather = weatherResponse;
        this.cdr.detectChanges();
      },
      error: (err) => {
        this.logger.error(err);
      },
    })
  }

  /**
     * Fetch stats of plant
     * @param plantId
     */

  fetchStats(plantId: string) {
    this.notificationList = [];
    this.isDeviceOffline = true;
    this.showNoDataScreen = false;

    let loaderSubject = new Subject<boolean>();

    this.prodService
      .getStats(plantId)
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe({
        next: (statResponse) => {
          if (statResponse?.data) {
            this.statData = statResponse.data;

            this.storageService.set(INVERTER_TYPE, this.statData.inverterType);

            if (this.statData.inverterType === this.noxInverterType.GTI) {
              this.baseUserService.inverterType.next(true);
            } else {
              this.baseUserService.inverterType.next(false);
            }

            this.storageService.set(PLANT_TYPE, this.statData.plantType);
            this.selectedPlantId = plantId;

            const strength = this.statData.stats?.wifi_signal_strength;
            localStorage.setItem('strength', JSON.stringify(strength));
            localStorage.setItem('deviceId', statResponse.data.deviceId);

            this.isDeviceOffline = this.checkDeviceOffline();
            localStorage.setItem('devicestatus', JSON.stringify(this.isDeviceOffline));

            this.showNoDataScreen = false;
          } else {
            this.showNoDataScreen = true;
          }

          this.fetchPlantOverview();
          this.cdr.detectChanges();
          loaderSubject.next(true);
        },

        error: (err) => {
          this.logger.error(err);
          this.statData = null;
          this.selectedPlantId = plantId;
          this.showNoDataScreen = true;

          this.fetchPlantOverview();
          this.cdr.detectChanges();
          loaderSubject.next(true);
          loaderSubject.complete();
        },

        complete: () => loaderSubject.complete(),
      });

    return loaderSubject;
  }

  /**
   * Toggle notification
   */
  toggleNotificationDropdown() {
    this.notificationDropdownVisible = !this.notificationDropdownVisible;
  }

  /**
   * Navigate to plant detail
   */
  navigateToPlantDetail() {
    this.router.navigate(['customer/plant-detail', this.selectedPlantId], {
      state: { reset: false },
    });
  }

  navigateToSolarRoofTopDetail(arg0: PlantDetail | undefined) {
    if (arg0?.lat && arg0.lon) {
      this.baseUserService.selectedPlantDetail.next(arg0);
      this.router.navigate(['customer/solar-rooftop']);
    } else {
      this.toastr.info('Plant not able to locate');
    }
  }

  /**
   *
   * @returns
   */
  private checkDeviceOffline(): boolean {
    if (!this.statData?.stats) {
      return true;
    }
    // Current timestamp
    const currentTime: number = Date.now();

    // Response timestamp
    const responseTime: number =
      this.statData?.stats.last_updated_timestamp * 1000;

    // Difference in hours
    const hours: number = DateUtils.calculateHoursDifference(
      currentTime,
      responseTime,
    );

    // If offline for more than 1 hour, short circuit and turn off wifi
    if (hours > 1) {
      return true;
    }
    return false;
  }
  clickOutside(selection: string) {
    if (selection === this.selectionType.yearly) {
      this.yearDropdownVisible = false;
    } else if (selection === this.selectionType.monthly) {
      this.dropdownVisible = false;
    } else if (selection === this.selectionType.notification) {
      this.notificationDropdownVisible = false;
    } else if (selection === this.selectionType.trendType) {
      this.enableTrendDropdown = false;
    }
  }
  switchTrends(noxDropdown: NoxDropdown) {
    if (noxDropdown.key === 'consumption') {
      this.selectedTrend = noxDropdown;
      this.generationData = false;
    } else {
      this.selectedTrend = noxDropdown;
      this.generationData = true;
    }
  }
  goBack(): void {
    if (this.user && this.user?.user_type === UserType.SYSTEM_INTEGRATOR) {
      let url = `/system-integrator/plant-management`;
      this.baseUserService.router.navigate([url]);
    }
  }
}
